import {
  IconAdjustments,
  IconChartArcs,
  IconChartBar,
  IconChevronRight,
  IconDashboard,
  IconDeviceDesktopPlus,
  IconDotsVertical,
  IconLock,
  IconLogs,
  IconRadar,
  IconScreenshot,
  IconSettings,
  IconSettings2,
  IconStatusChange,
  IconTimeDuration0,
  IconVolume,
} from "@tabler/icons-react";

import { RocketIcon } from "lucide-react";

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/client/components/shad/sidebar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/client/components/shad/dropdown-menu";
import { usePdarView } from "./hooks/usePadrView";
import { useMemo } from "react";

export const PdarOptions = () => {
  const { setView, view } = usePdarView();

  const title = useMemo(() => {
    if (view === "pdars") return "Pdars View";
    if (view === "logs") return "Logs View";
    if (view === "analytics") return "Analytics View";

    return "Controls View";
  }, [view]);

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="h-8 w-8 -ml-1 flex items-center justify-center rounded-full bg-sidebar-accent">
                <IconSettings className="size-4 text-purple-300/50" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{title}</span>
                <span className="text-muted-foreground truncate text-xs">
                  Switch PDAR Views
                </span>
              </div>
              <IconChevronRight className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg border dark:border-neutral-600/50 bg-background/50 backdrop-blur-sm"
            side={"right"}
            align="end"
            sideOffset={16}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <div className="h-8 w-8 -ml-1 flex items-center justify-center rounded-full bg-neutral-950">
                  <IconRadar className="size-4" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">PDAR</span>
                  <span className="text-muted-foreground truncate text-xs">
                    System ready to be armed
                  </span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={() => setView("main")}>
                <IconAdjustments />
                Controls
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setView("pdars")}>
                <IconRadar />
                Pdars
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setView("analytics")}>
                <IconChartBar />
                Analytics
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setView("logs")}>
                <IconLogs />
                Logs
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <IconVolume />
              Audio Off
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
